export default "__VITE_ASSET__C3j32_dk__"